import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_home/blog')({
  component: BlogLayout,
})

function BlogLayout() {
  return <Outlet />
}
